import React, { FunctionComponent } from 'react';

import searchEmptyState from './search-empty-state.svg';
import './semantic-no-results.scss';

const SemanticNoResults: FunctionComponent = () => (
  <div className="semantic-no-results">
    <img alt="" aria-hidden="true" className="semantic-no-results__illustration" src={searchEmptyState} />
    <p className="semantic-no-results__heading">No assets found</p>
    <p className="semantic-no-results__subtext">
      Check spelling, try broader terms, or remove a filter. Still stuck?
      <br />
      Classic Search handles exact keywords, tags, and SKUs.
    </p>
  </div>
);

export default SemanticNoResults;
